<template>
  <v-dialog
    v-model="active"
    width="40%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Integración
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="integracion">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Evaluado"
                :value="getFullName(integracion.Derivacion.Programacion.Expediente.Personal)"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Motivo de evaluación"
                :value="integracion.CatMotivoEvaluacion.title"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Tipo de evaluación"
                :value="integracion.CatTipoEvaluacion.title"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-card
                color="primary"
                class="card"
              >
                <v-card-title class="justify-center">
                  {{ integracion.CatResultado.title }}
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <div class="text-subtitle-2">
                          Número de certificado
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        align="right"
                      >
                        <div class="text-subtitle-2">
                          {{ integracion.numeroCertificado }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-subtitle-2">
                          Fecha de evaluación
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        align="right"
                      >
                        <div class="text-subtitle-2">
                          {{ integracion.fechaEvaluacion }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-subtitle-2">
                          Fecha de certificación
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        align="right"
                      >
                        <div
                          v-if="integracion.fk_idCatResultado !== 2"
                          class="text-subtitle-2"
                        >
                          {{ integracion.fechaCertificacion }}
                        </div>
                        <div
                          v-else
                          class="text-subtitle-2"
                        >
                          No aplica
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div class="text-subtitle-2">
                          Fecha de vencimiento
                        </div>
                      </v-col>
                      <v-col
                        cols="6"
                        align="right"
                      >
                        <div
                          v-if="integracion.fk_idCatResultado !== 2"
                          class="text-subtitle-2"
                        >
                          {{ integracion.fechaVencimiento }}
                        </div>
                        <div
                          v-else
                          class="text-subtitle-2"
                        >
                          No aplica
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="integracion.URL !== ''"
              cols="12"
              align="center"
            >
              <v-btn
                color="secondary"
                @click="download(integracion.URL)"
              >
                Descargar CUP
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    integracion: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
